import { ref } from "vue";

/**
 * 店舗間定期配達登録 UI状態管理
 * ダイアログ表示・ローディング・モードフラグを一元管理する
 */
export const useScheduledDeliveryRegisterUiState = () => {
  const errdialog = ref<boolean>(false); //エラーダイアログ
  const errMessage = ref<string>(""); //エラーメッセージ
  const updateMode = ref<boolean>(false);
  const deleteMode = ref<boolean>(false);

  //Loading
  const overlay = ref<boolean>(false);

  //ダイアログ初期化
  const displayConfirmDialog = ref<boolean>(false);
  const displayCompletedDialog = ref<boolean>(false);
  const hasAttemptedConfirm = ref<boolean>(false);

  return {
    errdialog,
    errMessage,
    updateMode,
    deleteMode,
    overlay,
    displayConfirmDialog,
    displayCompletedDialog,
    hasAttemptedConfirm,
  };
};
